import { reactive } from 'vue'

const config = reactive({
    uri: ''
})

export { config }
